'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _resource = require('../resource');

var _resource2 = _interopRequireDefault(_resource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Signup = function (_Resource) {
    (0, _inherits3.default)(Signup, _Resource);

    function Signup() {
        (0, _classCallCheck3.default)(this, Signup);
        return (0, _possibleConstructorReturn3.default)(this, (Signup.__proto__ || (0, _getPrototypeOf2.default)(Signup)).apply(this, arguments));
    }

    (0, _createClass3.default)(Signup, [{
        key: 'create',


        /**
         * @api {post} /v1/signup create
         * @apiGroup Signup
         * @apiName create
         * @apiDescription Add a new Gigwalk user.
         * @apiParam {Object} user
         * @apiExample {js} Example:
         *             gigwalk.signup.create({...})
         */
        value: function create(params) {
            return this.client.post('/v1/signup', (0, _extends3.default)({}, params.user));
        }

        /**
         * @api {post} /v1/signup/bulk bulkCreate
         * @apiGroup Signup
         * @apiName bulkCreate
         * @apiDescription Add a list of Gigwalk users.
         * @apiParam {Object[]} users
         * @apiExample {js} Example:
         *             gigwalk.signup.bulkCreate({...})
         */

    }, {
        key: 'bulkCreate',
        value: function bulkCreate(params) {
            var data = {
                users: params.users
            };

            return this.client.post('/v1/signup/bulk', data);
        }

        /**
         * @api {post} /v1/accept_invitation accept
         * @apiGroup Signup
         * @apiName accept
         * @apiDescription Accept an invitation to become a Gigwalk user.
         * @apiParam {String} first_name
         * @apiParam {String} last_name
         * @apiParam {String} password
         * @apiParam {String} invite_hash
         * @apiParam {Boolean} [check_expired]
         * @apiExample {js} Example:
         *             gigwalk.signup.accept({...})
         */

    }, {
        key: 'accept',
        value: function accept(params) {
            return this.client.post('/v1/accept_invitation', (0, _extends3.default)({}, params));
        }
    }]);
    return Signup;
}(_resource2.default);

exports.default = Signup;
//# sourceMappingURL=index.js.map